import styled, { css } from 'styled-components';
import Text from '../Typography/Text';
import Icon from '../Icon';

// note: AccordionPanelWrapper styles will be overridden based on [variation]
export const AccordionPanelWrapper = styled.div`
  border-bottom: 1px solid ${({
  theme
}) => theme.palette.border};
`;

// note: AccordionHeaderButton styles will be overridden based on [variation]
export const AccordionHeaderButton = styled.button`
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: ${({
  theme
}) => theme.spacing.md};
`;
export const AccordionHeaderText = styled(Text)`
  flex-grow: 1;
`;
export const AccordionHeaderIconStyled = styled(Icon)`
  transition: transform 250ms ease-in;
  transform: rotate(${({
  $rotate
}) => $rotate ? '180deg' : '0deg'});
`;
const variationBorderlessStyles = css`
  ${AccordionPanelWrapper} {
    border-bottom: none;
  }
`;
const variationGroupStyles = css`
  ${AccordionPanelWrapper} {
    border-bottom: none;
    margin-bottom: ${({
  theme
}) => theme.spacing.md};
  }

  ${AccordionHeaderButton} {
    background-color: ${({
  theme
}) => theme.palette.backgroundSecondary};
    border-radius: ${({
  theme
}) => theme.smallBorderRadius};
  }
`;
export const AccordionWrapper = styled.div`
  ${({
  $variation
}) => {
  if ($variation === 'group') return variationGroupStyles;
  if ($variation === 'borderless') return variationBorderlessStyles;
  return undefined;
}}
`;
//# sourceMappingURL=styles.js.map